import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Button } from "@shadcn-in-nx/ui/button";
import { X, CheckCircle, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ReportDetail({ report, onClose, onResolve }) {
    const navigate = useNavigate();

    return (
        <Card className="fixed right-6 top-24 w-[420px] max-h-[calc(100vh-120px)] overflow-y-auto z-50 shadow-lg border-2">
            <CardHeader className="pb-3 flex flex-row items-center justify-between">
                <CardTitle className="text-lg">Report Detail</CardTitle>
                <Button variant="ghost" size="sm" onClick={onClose}><X className="h-4 w-4" /></Button>
            </CardHeader>
            <CardContent className="space-y-4">
                <div className="flex gap-2 flex-wrap">
                    <Badge variant="outline">{report.type}</Badge>
                    <Badge variant="outline">{report.category || "unknown"}</Badge>
                    {report.resolved && <Badge className="bg-green-100 text-green-800">Resolved</Badge>}
                </div>

                <div className="space-y-2 text-sm">
                    <Row label="Company" value={report.companyName} />
                    <Row label="User ID" value={report.userId || "N/A"} />
                    <Row label="Workflow" value={report.workflowId || "N/A"} />
                    <Row label="Date" value={new Date(report.createdAt).toLocaleString()} />
                    {report.resolvedAt && <Row label="Resolved" value={new Date(report.resolvedAt).toLocaleString()} />}
                </div>

                <div>
                    <p className="text-sm font-medium mb-1">Objective</p>
                    <p className="text-sm bg-muted p-3 rounded">{report.objective}</p>
                </div>

                <div>
                    <p className="text-sm font-medium mb-1">Full Description</p>
                    <p className="text-sm bg-muted p-3 rounded whitespace-pre-wrap">{report.description}</p>
                </div>

                <div className="flex gap-2">
                    {report.stepChatId && (
                        <Button variant="outline" size="sm" onClick={() => navigate(`/admin/chats/${report.stepChatId}`)}>
                            <ExternalLink className="h-4 w-4 mr-1" />View Chat
                        </Button>
                    )}
                    <Button size="sm" variant={report.resolved ? "outline" : "default"} onClick={() => onResolve(report.id, !report.resolved)}>
                        <CheckCircle className="h-4 w-4 mr-1" />
                        {report.resolved ? "Unresolve" : "Resolve"}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex justify-between">
            <span className="text-muted-foreground">{label}</span>
            <span className="font-medium">{value}</span>
        </div>
    );
}
